import * as icons from 'ionicons/icons';
import type { JSX } from 'ionicons'
import { defineCustomElement as defineIonIcon } from 'ionicons/components/ion-icon.js';
import { FC, createElement, HtmlHTMLAttributes } from 'react';
defineIonIcon()

const sizeMap: any = {
    xxs: '8px',
    xs: '12px',
    small: '16px',
    medium: '20px',
    large: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',
}

export interface MixIconProps extends HtmlHTMLAttributes<HTMLDivElement> {
    value: string,
    size?: 'xxs' | 'xs' | 'small' | 'medium' | 'large' | 'xl' | 'xxl' | 'xxxl' | number | 'inherit',
    color?: string
}

export const MixIcon: FC<MixIconProps> = (props) => {
    const { value, color, size, ...others } = props;
    others.style = {
        ...props.style,
        color,
        fontSize: sizeMap[size ?? 'medium'] ?? size,
        width: sizeMap[size ?? 'medium'] ?? size,
    };
    if (!props.value) {
        return createElement<JSX.IonIcon>('ion-icon', { ...others, src: '', })
    }
    const segs = props.value.split(':')
    if (segs.length === 2) {
        const svg = (icons as any)[segs[1]]
        return createElement<JSX.IonIcon>('ion-icon', { ...others, src: svg })
    } else {
        return createElement<JSX.IonIcon>('ion-icon', { ...others, src: '' })
    }
}
